var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 24,
    viewBox: "0 0 95 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9146 23.9029H7.57669L11.357 3.19358H7.69316L3.04474 23.9029H0L5.17965 0H15.258L10.9146 23.9029Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7563 0L26.1276 23.9029H22.6891L23.0912 18.7696H18.2008L16.7731 23.9029H13.3347L20.3725 0H27.7563ZM22.4436 3.64421H24.2977L23.3728 15.5761H19.1057L21.3176 7.77823L22.4436 3.64421Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7269 0.000147187L78.0982 23.903H74.6597L75.0618 18.7698H70.1714L68.7437 23.903H65.3053L72.3431 0.000147187H79.7269ZM74.4142 3.64436H76.2683L75.3434 15.5762H71.0763L73.2882 7.77838L74.4142 3.64436Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7822 6.75942L35.486 2.91929L42.0655 2.95847L42.6285 0H32.6507L28.3074 23.9029H38.2852L40.9193 9.26727L41.4824 6.11287L34.7822 6.75942ZM32.2083 20.964L34.2192 9.91382L37.501 9.65912L35.47 20.964H32.2083Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1889 6.75957L86.8927 2.91943L93.4722 2.95861L94.0353 0.000147223L84.0575 0.000147187L79.7141 23.903H89.6919L92.3261 9.26741L92.8891 6.11302L86.1889 6.75957ZM83.6151 20.9641L85.6259 9.91397L88.9077 9.65926L86.8768 20.9641H83.6151Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8582 3.11829H68.8311L69.6629 0.000147187H62.4177L59.6006 10.3487H57.6815L52.6317 0.000147187H49.128L50.4419 3.00988L53.6442 10.3487H50.8598L48.0407 20.8818H44.7081L44.1018 24H50.4812L53.2066 13.5896H55.5211L59.6499 24H63.1537L61.8398 20.9903L58.5869 13.638L62.0391 13.6514L64.8582 3.11829Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a50d98b870a9ef5e6b33f39c36a5eb44.svg";
export { ForwardRef as ReactComponent };